import { render, staticRenderFns } from "./AddCustomerInfo.vue?vue&type=template&id=bf670a58&scoped=true&"
import script from "./AddCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./AddCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerInfo.vue?vue&type=style&index=0&id=bf670a58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf670a58",
  null
  
)

export default component.exports